import TitleSection from "../components/TitleSection";
import DataPartners from "../components/DataPartners";
import Resources from "../components/Resources";
import data from "../../../datasets/usecases/portfoliomonitoring";
import Recipes from "../components/Recipes";
// import { PricingGetStarted } from "../../Pricing/components/PricingGetStarted";

export const PortfolioMonitoring = () => {
  return (
    <div className="portfolio_monitoring">
      <TitleSection data={data} />
      <Recipes data={data} />
      <DataPartners dataPartners={data.dataPartners} />
      <Resources {...data} />
      {/* <PricingGetStarted /> */}
    </div>
  );
};
